// extracted by mini-css-extract-plugin
export default {"container":"_2sG21xZb","transparent":"_8--By5y3"};